import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selectedStyle: null,
    isOpenSoldStyleChangePopup: false,
    soldFolderId: null
}

const soldStyleFavSlice = createSlice({
    name: 'soldStyleFav',
    initialState,
    reducers: {
        setSoldStyleFavInfo: (state, action) => {
            state.selectedStyle = action.payload.selectedStyle
            state.isOpenSoldStyleChangePopup = true
            state.soldFolderId = action.payload.soldFolderId
        },
        closeSoldStyleChangePopup: (state) => {
            return initialState
        }
    }
})

export const { setSoldStyleFavInfo, closeSoldStyleChangePopup } =
    soldStyleFavSlice.actions

export const useSoldStyleFav = (state) => state.soldStyleFav

export default soldStyleFavSlice.reducer
